import React from "react";
import { useIntl } from "react-intl";
import { gql } from "@apollo/client";

import { IconButton, Tooltip } from "@mui/material";
import { CurrencyUsd as PaymentIcon } from "mdi-material-ui";

export default function PaymentProviderIcon({ order }) {
  const intl = useIntl();

  let tooltip = "";
  if (order.paymentDate) {
    const paymentDateStr = intl.formatDate(order.paymentDate, {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });

    tooltip = `Payé le ${paymentDateStr}`;
  }

  if (order.paymentProvider === "STRIPE" && order.paymentId)
    return (
      <Tooltip title={tooltip}>
        <IconButton
          onClick={(event) => event.stopPropagation()}
          component="a"
          href={`${process.env.REACT_APP_STRIPE_BASE_URL}/payments/${order.paymentId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img width="24" src={require("./images/stripe.png")} alt="Stripe" />
        </IconButton>
      </Tooltip>
    );

  if (order.paymentProvider === "PAYPAL" && order.paymentId)
    return (
      <Tooltip title={tooltip}>
        <IconButton
          onClick={(event) => event.stopPropagation()}
          href={`${process.env.REACT_APP_PAYPAL_BASE_URL}/activity/payment/${order.paymentId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img width="24" src={require("./images/paypal.png")} alt="Paypal" />
        </IconButton>
      </Tooltip>
    );

  if (order.paymentId)
    return (
      <Tooltip title={tooltip}>
        <IconButton onClick={(event) => event.stopPropagation()}>
          <PaymentIcon />
        </IconButton>
      </Tooltip>
    );

  return null;
}

PaymentProviderIcon.fragments = {
  order: gql`
    fragment OrderSidebar_Cart_PaymentProviderIcon_order on Order {
      paymentId
      paymentProvider
      paymentDate
    }
  `,
};
